import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Confirm, Message, Loader } from 'semantic-ui-react';
import AddButton from '../../components/Button/AddButton';

import { Container, Header, Title } from './styles';
import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import Table from '../../components/Table';
import Modal from './Modal';

import { GET_MALLS } from '../../services/graphql/queries';

const columns = [
  { id: 'name', label: 'Nombre', minWidth: 100 },
  { id: 'code', label: 'Código', minWidth: 100 },
  { id: 'country_name', label: 'País', minWidth: 100 },
  { id: 'active', label: 'Activo', size: 'small' },
  {
    id: 'actions',
    label: 'Acciones',
    size: 'small',
    align: 'left'
  }
];

export default function Malls() {
  const [open, setOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState({});
  const [countries, setCountries] = useState([]);

  const { loading, error, data, refetch } = useQuery(GET_MALLS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (data) {
      if (data.getCountries) {
        setCountries(
          data.getCountries.map(country => ({
            key: country.id,
            text: country.name,
            value: country.id
          }))
        );
      }
    }
  }, [data]);

  function handleAdd() {
    setEdit(false);
    setOpen(true);
  }

  function handleEdit(data) {
    setEdit(true);
    setSelected(data);
    setOpen(true);
  }

  function handleModalClose() {
    refetch();
    setOpen(false);
  }

  return (
    <Container data-testid="malls-component">
      <Confirm
        open={confirmationOpen}
        onCancel={() => setConfirmationOpen(false)}
        cancelButton="No"
        confirmButton="Si"
        header="Eliminar registro"
        content="¿Estás seguro de que deseas eliminar este registro?"
      />
      <FlexContainer>
        <FlexChildren>
          <Header>
            <Title>Centros Comerciales</Title>
            <AddButton add onClick={handleAdd} />
          </Header>
          {loading && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}
          {!loading && !error && data && (
            <Table
              data={data ? data.getMalls.filter((data, index) => index !== 0) : null}
              columns={columns}
              handleEdit={handleEdit}
            />
          )}
          <Modal
            open={open}
            onClose={handleModalClose}
            edit={edit}
            countries={countries}
            selected={selected}
          />
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
